import Node from "./node";
export default class Store {
  constructor(options) {
    this.data = [];
    this.root = [];
    // this.checkedNodes = [];
    this.key = "id";
    for (let option in options) {
      if (options.hasOwnProperty(option)) {
        this[option] = options[option];
      }
    }
    this._initNode(this.data);
  }
  _initNode(data) {
    data.forEach(item => {
      this.root.push(new Node(item));
    });
  }
  getCheckedNodes() {
    // const key = this.key;
    const checkedNodes = [];
    const allNode = this.root;
    allNode.forEach(item => {
      if (item.checked) {
        checkedNodes.push(item);
      }
    });
    // this.checkedNodes.forEach(item => {
    //   const checkedNodeIds = checkedNodes.map(item => item[key]);
    //   if (!checkedNodeIds.includes(item[key])) {
    //     checkedNodes.push(item);
    //   }
    // });
    // this.checkedNodes = checkedNodes;
    return checkedNodes;
  }
  // _getCheckedKeys() {
  //   const key = this.key;
  //   const checkedKeys = {};
  //   this.checkedNodes.forEach(item => {
  //     checkedKeys[(item || {})[key]] = true;
  //   });
  //   return checkedKeys;
  // }
  setCheckedNodes(array) {
    const key = this.key;
    const checkedKeys = {};
    array.forEach(item => {
      checkedKeys[(item || {})[key]] = true;
    });
    this._setCheckedKeys(checkedKeys);
  }
  _setCheckedKeys(checkedKeys) {
    const key = this.key;
    const allNodes = this.root;
    let keys = Object.keys(checkedKeys);
    allNodes.forEach(item => item.setChecked(false));
    for (let i = 0; i < allNodes.length; i++) {
      const node = allNodes[i];
      const nodeKey = node[key].toString();
      let checked = keys.indexOf(nodeKey) > -1;
      if (!checked) {
        if (node.checked) {
          node.setChecked(false);
        }
      } else {
        node.setChecked(true);
      }
    }
  }
  setData(newVal) {
    this._initNode(newVal);
  }
  append(data) {
    if (!Array.isArray(data)) {
      throw new Error("data must be a array");
    }
    data.forEach(item => {
      this.root.push(new Node(item));
    });
  }
  clear() {
    this.root.splice(0, this.root.length);
    this.data.splice(0, this.data.length);
  }
}
